<template>
  <div>
    <el-table
      :data="callInfoList"
      :show-header="false"
      :cell-style="{
        borderColor: '#D9D9D9',
        'border-width': '5px',
        'background-color': 'white',
        'cursor': 'pointer'
      }"
      :row-class-name="tablerowclassname"
      @row-click="clickOneRecord"
      :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
    >
      <template slot="empty">
        <p style="text-align: center; font-size: 12px">
          {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
        </p>
      </template>
      <el-table-column width="20px">
        <template slot-scope="scope">
          <span style="left: 12px; top: 10px; position: absolute; width: 30px; z-index: 100; color: #3e8f92; font-size: 12px;">
            {{ scope.row && scope.row.similarity && scope.row.similarity != '0%' ? scope.row.similarity : '--%' }}
          </span>
          <div style="display: flex" v-if="scope.row && Boolean(scope.row.heart_change_distance)">
            <div id="img_head_back_table"  v-bind:style="{ top: 32 + scope.row.heart_change_distance + 'px',height: 25 - scope.row.heart_change_distance + 'px',}"></div>
            <img :src="scope.row.selected || (scope.row.hasOwnProperty('issue_id') && scope.row['issue_id'] == $store.state.phone.selectedId) ||
            (!scope.row.hasOwnProperty('issue_id') && scope.row['type'] + getTelNum(scope.row) == $store.state.phone.selectedId) ? heart_white_current : heart_white" 
            class="img_heart_table"
            />
          </div>
          <div style="display: flex" v-else>
            <img :src="scope.row.selected || (scope.row.hasOwnProperty('issue_id') && scope.row['issue_id'] == $store.state.phone.selectedId) ||
            (!scope.row.hasOwnProperty('issue_id') && scope.row['type'] + getTelNum(scope.row) == $store.state.phone.selectedId) ? heart_white_current : heart_white" 
            class="img_heart_table"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <span style="display: flex; align-content: center; flex-wrap: wrap; justify-content: center;">
            <span class="message_qu_name">
              {{ getCustomerName(scope.row) }}
            </span>
            <br />
            <img class="img_questioner" :src="getCustomerLogo(scope.row)" />
            <br />
            <!-- <span style="margin-left: 30px">
              <icon name="small_star"></icon>
              <icon name="small_star"></icon>
            </span> -->
          </span>
        </template>
      </el-table-column>
      <el-table-column width="100px">
        <template slot-scope="scope">
          <div style="width: 100px; text-align: center">
            <div class="line-type">
              <el-tag style="margin-top: 5px;"
                size="mini"
                :type="!checkIfInternalLine(getTelNum(scope.row)) ? 'warning' : ''"
              >
                {{ getLineType(getTelNum(scope.row)) }}
              </el-tag>
            </div>
            <span class="message_time" :class="isLongtimeWaiting(scope.row) ? 'waiting-long-color' :''" > {{ scope.row.time }}</span>
            <div class="arrow-line">
              <i
                v-if="checkIfOutBound(scope.row)"
                class="el-icon-caret-left arrow-icon-left"
                :class="getLineClass(scope.row)"
              ></i>
              <div style="width:95px;border-top:2px" :class="getLineClass(scope.row)" 
                :style="{ 'border-top-style': callStatus === $store.state.phone.CALL_STATUS_WAITING ? 'dotted':'solid' }"
              ></div>
              <i
                v-if="!checkIfOutBound(scope.row)"
                class="el-icon-caret-right arrow-icon-right"
                :class="getLineClass(scope.row)"
              ></i>
            </div>
            <div class="message_presence" 
            >{{getPresence(scope.row)}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <span class="message_op_name">
            {{  getAssigneeName(scope.row) }}</span
          >
          <br />
          <img
            :src="getAssigneeImg(scope.row)"
            class="img_operatorPi"
          />
          <div style="padding-bottom: 0px"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Vue from "vue";
import questioner_logo from '@/assets/img/user_logo.png'
import heart_white_current from '@/assets/img/heart-white-current.svg'
import heart_hover from '@/assets/img/heart-hover.svg'
import heart_white from '@/assets/img/heart-white.svg'
import exclamation_img from '@/assets/img/exclamation.svg'
import Utils from '@/utils'
import VueUtils from '@/utils/utils.js'
export default {
  components: {},
  props:['callStatus','callInfoList'],
  data() {
    return {
      heart_white_current:heart_white_current,
      heart_white:heart_white,
      heart_hover:heart_hover,
      clickedRow: {},
    };
  },
  mounted(){},
  watch: {},
  computed:{},
  beforeDestroy: function () {},
  methods: {
    checkIfInternalLine(telNum) {
      return Utils.checkIfInternalLine(telNum)
    },
    getLineType(telNum) {
      return this.checkIfInternalLine(telNum) ? "内線" : "外線";
    },
    getCustomerName(userInfo) {
      if (this.callStatus != this.$store.state.phone.CALL_STATUS_END) {
        return userInfo.customer_name
      } else {
        return VueUtils.computeFullName(userInfo.lastname, userInfo.firstname);
      }
    },
    getCustomerLogo(userInfo) {
      return userInfo.logo_url ? userInfo.logo_url : questioner_logo;
    },
    checkIfOutBound(userInfo) {
      return userInfo.is_outbound === "1";
    },
    checkIfIsOnhold(userInfo){
      return userInfo.isOnHold;
    },
    getLineClass(userInfo){
      let telNum = this.getTelNum(userInfo)
      // ending call
      let isInternal =  this.checkIfInternalLine(telNum)
      switch(this.callStatus){
        case this.$store.state.phone.CALL_STATUS_END: 
          return 'end-call-color'
        case this.$store.state.phone.CALL_STATUS_INCALL:
          return isInternal?'internal-call-color':'external-call-color'
        case this.$store.state.phone.CALL_STATUS_WAITING:
          return this.isLongtimeWaiting(userInfo) ? 'waiting-long-color' : isInternal?'internal-call-color':'external-call-color' 
      }
    },
    isLongtimeWaiting(userInfo){
      if( (this.callStatus === this.$store.state.phone.CALL_STATUS_WAITING) && userInfo.startTime){
        let timeArr = userInfo.startTime.split(':')
        let seconds = Number(timeArr[0]) * 60 + Number(timeArr[1])
        return seconds > this.$store.state.phone.LONG_TIME_WAITING
      }
      return false 
    },
    getPresence(userInfo){
      if(this.callStatus == this.$store.state.phone.CALL_STATUS_END){
        return 'クローズ'
      }else{
        return userInfo.isWaiting ? (this.isLongtimeWaiting(userInfo)? '閾値超え待ち呼' :'待ち呼'): this.checkIfOutBound(userInfo) ? 'OUT応対中' : (this.checkIfIsOnhold(userInfo) ? 'IN保留中' : 'IN応対中')
      }
    },
    getAssigneeName(userInfo){
      if (this.callStatus == this.$store.state.phone.CALL_STATUS_WAITING && userInfo.is_outbound === "0"){
        return '担当者未定'
      }else{
        return this.$store.state.sysInit.user_name
      }
    },
    getAssigneeImg(userInfo){
      if (this.callStatus == this.$store.state.phone.CALL_STATUS_WAITING && userInfo.is_outbound === "0"){
        return exclamation_img
      }else{
        return this.$store.state.sysInit.operator_logo
      }
    },
    clickOneRecord(row, event, colum){
      this.clickedRow = row;
      let preType = localStorage.getItem('callType');
      // localStorage.removeItem('selectedId');
      localStorage.setItem('callType', this.callStatus);
      localStorage.setItem('number', this.getTelNum(row));
      let type = localStorage.getItem('callType');
      if(preType == '3'){
        _.forEach(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo, function(value,key) {
          value.selected = false;
          value.type = preType;
        });
        Vue.set(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo,0,this.$store.state.sysInit.piRecordInfoObj.piRecordInfo[0]);
      }
      if(preType == '1'){
        _.forEach(this.$store.state.phone.waitingList, function(value,key) {
          value.selected = false; 
          value.type = preType;
        });
        Vue.set(this.$store.state.phone.waitingList,0,this.$store.state.phone.waitingList[0]);
      }
      if(preType == '2'){
        _.forEach(this.$store.state.phone.inCallList, function(value,key) {
          value.selected = false; 
          value.type = preType;
        });
        Vue.set(this.$store.state.phone.inCallList,0,this.$store.state.phone.inCallList[0]);
      }
      row['selected'] = true;
      if(type == '3'){
        this.$store.state.phone.selectedId = row.issue_id;
        // localStorage.setItem('selectedId', row.issue_id);
        Vue.set(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo,0,this.$store.state.sysInit.piRecordInfoObj.piRecordInfo[0]);
      }
      if(type == '1'){
        this.$store.state.phone.selectedId = type + this.getTelNum(row);
        // localStorage.setItem('selectedId', type + row.telnum);
        Vue.set(this.$store.state.phone.waitingList,0,this.$store.state.phone.waitingList[0]);
      }
      if(type == '2'){
        this.$store.state.phone.selectedId = type + this.getTelNum(row);
        // localStorage.setItem('selectedId', type + row.telnum);
        Vue.set(this.$store.state.phone.inCallList,0,this.$store.state.phone.inCallList[0]);
      }
      this.$forceUpdate();

      this.$emit('click-one-row',row,this.callStatus)
    },

    tablerowclassname({row, rowindex}) {
      // if(this.clickedRow){
        if(row && row["selected"] || (row && row.hasOwnProperty('issue_id') && row['issue_id'] == this.$store.state.phone.selectedId) ||
          (row && !row.hasOwnProperty('issue_id') && row['type'] + this.getTelNum(row) == this.$store.state.phone.selectedId)
        ){
          return 'selected-row';
        }else{
          return 'non-selected-row';
        }
      // }else{
      //   return 'non-selected-row';
      // }
      
    },
    getTelNum(row){
      return row.Tnumber ? row.Tnumber : row.telnum
    }
  },
};
</script>
<style lang="scss" scoped>
.selected-row,.selected-row td{
  background: #ffeaea !important;
}
.non-selected-row,.non-selected-row td{
  background: white !important;
}
.img_questioner {
  background-color: #f2f2f2;
  // padding: 5px;
  border-radius: 50%;
  margin-left: 25px;
  width: 45px;
  height: 45px;
}
.img_operatorPi {
  // padding: 5px;
  border-radius: 50%;
  margin-left: 11px;
  width: 45px;
  height: 45px;
}
.message_presence {
  font-size: 10px;
}
.message_op_name {
  margin-left: 10px;
  font-size: 10px;
}
.message_qu_name {
  margin-left: 24px;
  font-size: 10px;
}
.message_time {
  // margin-left: 15px;
  font-size: 10px;
}

#img_head_back_table {
  background-color: #ff56a7;
  position: absolute;
  width: 25px;
  left: 10px;
  z-index: 10;
}
.img_heart_table {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 32px;
  left: 10px;
  z-index: 20;
}

.el-dropdown-link-phone {
  cursor: pointer;
  color: #409eff;
}
.el-table tr td.td-is-left {
  text-align: left;
}
.line-type {
  display: flex;
  zoom: 0.7;
}
.arrow-line {
  display: flex;
  align-items: center;
}
.arrow-icon-right {
  margin-left: -5px;
  margin-top: 1px;
}
.arrow-icon-left {
  margin-right: -5px;
  margin-top: 1px;
}
.internal-call-color {
  color: #00b2f2;
}
.external-call-color {
  color: #e6a23c;
}
.end-call-color{
  color: #808080;
}
.waiting-long-color {
  color: red
}
.heartHover{
  object-fit: none;

}
</style>

